<script lang="ts">
  import type { PrintSelectionPreviewRow } from "../../../../../../../../_shared/_logic/print-selection-preview"
  import type { WorkOrderPrintRowSelection } from "../../../../../../../../../../../../../../../../api/kehrblatt/letters"
  import LetterRecipientTag from "../../../../../../_shared/_modules/letter-recipient-tag"
  import { buildLetterDeliveryRecipientDisplay } from "../../../../../../_shared/_logic/print-presentation"
  let { row }: { row: PrintSelectionPreviewRow } = $props()
  const selection = $derived(row.selection_row as Partial<WorkOrderPrintRowSelection> | null)
  const ignored = $derived(row.recommendation_reason_code === "letter_delivery_ignored_by_user")
  const recipient = $derived(
    buildLetterDeliveryRecipientDisplay({
      mode: selection?.mode,
      recipientName: selection?.recipient_name ?? row.recipient_label,
      recipientAddress: selection?.recipient_address,
      propertyAddress: selection?.property_address,
    }),
  )
</script>
<LetterRecipientTag
  label={ignored ? "Kein Empfänger erforderlich" : recipient.label}
  address={ignored ? "" : recipient.addressLabel}
  hint={row.status_label}
/>
